import axios from "axios";

const state = {
  panelUsers: [],
  panelUserData: {},
  loading: false
};

const getters = {
  allPanelUsers: (state) => state.panelUsers,
  panelUser: (state) => state.panelUserData,
  loading: (state) => state.loading,
};

const actions = {
  getPanelUsers({ commit }, userPageData) {
    commit('setLoading', true)
    return axios
      .get(
        `/api/panel/paneluser/panel-user-list?page=${userPageData.pageNumber
        }&size=${userPageData.pageSize}&search=${userPageData.search}`
      )
      .then((response) => {
        
        console.log("response", response);
        commit("setPanelUsers", response.data.payload.items);
        commit('setLoading', false)
        return response.data.payload;
      });
  },
  postAddPanelUser({ commit }, userData) {
    console.log("userData", userData);
    return axios
      .post(
        '/api/panel/paneluser/panel-user-create', userData
      )
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  },
  putUpdatePanelUser({ commit }, userData) {
    let updateUserObject = { ...userData };
    delete updateUserObject.email;
    // delete updateUserObject.roles;
    return axios
      .put(
        '/api/panel/paneluser/panel-user-update', updateUserObject
      )
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  },
  getPanelUser({ commit }, panelUser) {
    return axios.get(
      `/api/panel/paneluser/panel-user/${panelUser.id}`
    )
      .then((response) => {
        commit("setPanelUser", response.data.payload);
        return response.data.payload;
      });
  },
  getResetPanelUserPassword({ commit }, panelUser) {
    return axios.get(
      `/api/panel/auth/new-password/${panelUser.email}`
    )
      .then((response) => {
        
        console.log("response", response);
        return response;
      });
  },
  putUpdateUserStatus({ commit }, user) {
    return axios
      .put(
        '/api/panel/paneluser/panel-user-active-update', {
        "id": user.id,
        "active": user.active
      }
      )
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  }
};

const mutations = {
  setPanelUsers: (state, panelUsers) => {
    console.log(panelUsers)
    console.log(state.panelUsers)
    state.panelUsers = panelUsers;
  },
  setPanelUser: (state, panelUserData) => {
    state.panelUserData = panelUserData;
    state.panelUserData.role = panelUserData.role;
  },
  setLoading(state, value) {
    state.loading = value;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
